export default __webpack_public_path__ + "static/media/hearingaid-graph.b3a94fac.svg";